import { validateConfig } from '../config/validateConfig.js';
import { initMap } from '../map/setupMap.js';
import { buildStoryDOM } from '../dom/buildStoryDOM.js';
import { setupMarkers } from './setupMarkers.js';
import { setupInsetMap } from './setupInsetMap.js';
// import { setupKeyboardShortcuts } from './setupKeyboardShortcuts.js';
import { onMapLoad } from '../storyMap/onMapLoad.js';
import { setupDebugUtils } from '../utils/setupDebugUtils.js';
import { loadTerrain } from '../map/terrainUtils.js';

// Optional: expose internal state for debugging
import { state } from '../map/state.js';


window.__storyMapState = state;

export default function initStoryMap(config, externalData) {
  // 1. Validate config
  validateConfig(config);

  // 2. Set up DOM (header, chapters, footer)
  buildStoryDOM(config);

  // 3. Initialize map
  const map = initMap(config);


  if (!map.hasImage('building')) map.addImage('building', document.getElementById('building'));
  // 4. Optional 3D terrain
  if (config.use3dTerrain) {
    loadTerrain(map);
  }

  // 5. Debug tools (e.g., layer inspector, etc.)
  setupDebugUtils(map, config);

  // 6. Set up interactive map elements
  const marker = setupMarkers(map, config);
  const insetMap = setupInsetMap(map, config);

  // 7. Optional keyboard shortcuts (e.g., mask toggle)
  // enableMaskToggle(map, config.sources)

  // 8. Final post-load logic
  onMapLoad(map, config, externalData, insetMap, marker);
}